import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import queryBuilder from '@glittr/frontend-core/src/plugins/validation/queryBuilder';

export default (options: { validateFirstname: boolean, validateLastName: boolean }) => {
  return {
    ...queryBuilder.properties({
      contact: {
        type: 'object',
        properties: {
          street: {
            required: true, type: 'string',
          },
          postalCode: {
            required: true, type: 'string',
          },
          city: {
            required: true, type: 'string',
          },
          email: {
            required: true, type: 'string',
          },
          ...(options.validateFirstname ? {
            firstName: {
              required: true, type: 'string',
            },
          } : {}),
          ...(options.validateFirstname ? {
            lastName: {
              required: true, type: 'string',
            },
          } : {}),
        },
      },

    }),
  } as IJSONSchema
};
